import { Button, Form, message, Table } from "antd";
import { useEffect, useState } from "react";
import { fmtDate } from "../../extensions/utils";
import { getTableColumn, paymentsVids } from "../../extensions/helper";
import { serverFetch } from "../../server";
import { isMobile, menuSize } from "../../extensions/design";
import ClientItemPayment from "./client-item-payment"
import { AddFilter, FilterItem } from "../../controls";

const ClientPayments = ({ id, exposeOnRefresh }) => {
  const [form] = Form.useForm();
  const [itmPaymentsList, setItmPaymentsList] = useState([]);
  const [loading, setLoading] = useState(false);
	const [vidPayments, setVidPayments] = useState([]);
  const [accountPaymentVidOptions, setAccountPaymentVidOptions] = useState([]);
  const [filter, setFilter] = useState({});
  const [addingFilter, setAddingFilter] = useState(true);
  const getPaymentsData = () => {
    setLoading(true);
    serverFetch(`Payment/ByClient/${id}`)
      .then((data) => {
        setItmPaymentsList(data);
        console.log(data)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };
  useEffect(() => {
    getPaymentsData();
  }, [id]);

  const getAccountPaymentVids = () => {
    serverFetch(`payment/accounts/client/${id}`)
      .then((data) =>
        setAccountPaymentVidOptions(data.map((i) => ({ value: i.id, label: i.name })))
      )
      .catch((e) => message.error(e.userMessage));
  };

  useEffect(getAccountPaymentVids, [id]);

  const getVidPayments = () => {
    serverFetch("paymentvid")
      .then((data) =>
        setVidPayments(data.map((i) => ({ value: i.id, label: i.name })))
      )
      .catch((e) => message.error(e.userMessage));
  };

  useEffect(getVidPayments, []);
  const getPaymentVidLabel = (paymentVidId) => {
    const item = vidPayments.find((v) => v.value === paymentVidId);
    return item ? item.label : paymentVidId;
  };

  const getPaymentVid2Label = (paymentVid2Id) => {
    const item = vidPayments.find((v) => v.value === paymentVid2Id);
    return item ? item.label : paymentVid2Id;
  };

  const getVidLabel = (vid) => {
    const found = paymentsVids.find(item => item.value === vid);
    return found ? found.label : vid;
  };

  const filteredPaymentsVids = paymentsVids.filter(({ value }) => value !== 11 && value !== 12);
  
  const filterOptions = [
    { type: "vid", label: "Вид", inputType: "multiselect", options: filteredPaymentsVids },
    { type: "paymentVids", label: "Вид оплаты", inputType: "multiselect", options: vidPayments },
    { type: "basisPaymentVids", label: "Основание", inputType: "multiselect", options: accountPaymentVidOptions },
  ];

  const filterLabels = {
    vid: "Вид",
    paymentVids: "Вид оплаты",
    basisPaymentVids: "Основание",
  };

  const onFilterChange = (changedValues) => {
    setFilter(prev => ({ ...prev, ...changedValues }));
  };

  const handleAddTopFilter = (type) => {
    if (filter[type]) return;

    const option = filterOptions.find(opt => opt.type === type);
    onFilterChange({ [type]: { value: [], inputType: option?.inputType, options: option?.options } });
    setAddingFilter(false);
  };

  const renderFilterItem = (key, data) => {
    const option = filterOptions.find(f => f.type === key);

    return (
      <FilterItem
        key={key}
        type={option?.inputType}
        label={filterLabels[key] || key}
        value={data.value}
        options={option?.options}
        onChange={(val) => onFilterChange({
          [key]: {
            ...data,
            value: val
          }
        })}
        onRemove={() => {
          const { [key]: _, ...rest } = filter;
          setFilter(rest);
        }}
      />
    );
  };

  const filters = Object.entries(filter).map(([type, data]) => ({ type, ...data }));

  const isFilterMatch = (item, f) => {
    if (!f.value?.length) return true;

    if (f.type === "paymentVids") return f.value.includes(item.paymentVidId);
    if (f.type === "basisPaymentVids") return f.value.includes(item.paymentVid2Id);

    return f.value.includes(item[f.type]);
  };

  const filteredPaymentsList = itmPaymentsList.filter(item =>
    filters.every(f => isFilterMatch(item, f))
  );

  const filtersPanel = (
    <div className="filter-container-payments-client" style={isMobile
      ? { marginBottom: 8, padding: "0 4px", gridTemplateColumns: "1fr" }
      : { marginBottom: 8, gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
      {filters.length === 0 && !addingFilter && (<AddFilter availableFilters={filterOptions} usedFilters={filters.map(f => f.type)} onAdd={handleAddTopFilter}/>)}
      {filters.map((f) => renderFilterItem(f.type, f))}
      {filters.length < filterOptions.length && (
        addingFilter ? (<AddFilter availableFilters={filterOptions} usedFilters={filters.map(f => f.type)} onAdd={handleAddTopFilter}/>) : (
          filters.length !== 0 && (<Button onClick={() => setAddingFilter(true)} type="dashed" className="filter-add-button">+</Button>)
        )
      )}
    </div>
  );

  useEffect(() => {
    if (exposeOnRefresh) {
      exposeOnRefresh(() => getPaymentsData);
    }
  }, [exposeOnRefresh]);

  const columns = [
    getTableColumn("createdOn", "Дата", { type: "date", formatFn: fmtDate, width: 35 }, filteredPaymentsList),
    getTableColumn("paymentVidId", "Касса", { width: 50, render: (value) => getPaymentVidLabel(value)}, filteredPaymentsList),
    getTableColumn("vid", "Вид", { width: 60, render: (value) => getVidLabel(value)}, filteredPaymentsList),
    getTableColumn("syma", "Приход", { width: 30, type: "number", render: (_, record) => record.vid === 1 || record.vid === 2 ? Number(record.syma).toFixed(2) : ""}, filteredPaymentsList),
    getTableColumn("syma", "Расход", { width: 30, type: "number", render: (_, record) => record.vid === -1 ? Number(record.syma).toFixed(2) : ""}, filteredPaymentsList),
    getTableColumn("productName", "Основание", { type: "string", width: 50, render: (value, record) => {return value ? value : getPaymentVid2Label(record.paymentVid2Id); }}, filteredPaymentsList),
  ];
  const renderedTable = !isMobile ? [
    <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
      {filtersPanel}
      <Table
        dataSource={filteredPaymentsList}
        columns={columns}
        pagination={false}
        size="small"
        className="table-item"
        rowClassName={(_, index) => (index % 2 === 0 ? "row-even" : "row-odd")}
        summary={(pageData) => {
        const totalIn = pageData.reduce((sum, item) => sum + (item.vid === 1 || item.vid === 2? Number(item.syma || 0) : 0), 0);
        const totalOut = pageData.reduce((sum, item) => sum + (item.vid === -1 ? Number(item.syma || 0) : 0), 0);
        return (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={3}>
                <b style={{ float: "left" }}>Итого:</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3}>
                <b style={{float:"right"}}>{totalIn.toFixed(2)}</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4}>
                <b style={{float:"right"}}>{totalOut.toFixed(2)}</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell />
            </Table.Summary.Row>
          </Table.Summary>
        );
      }}
      />
    </Form>
  ] : [
<Form style={{ height: window.innerHeight - menuSize - 22, display: "flex", flexDirection: "column", marginTop: "8px" }}>
  {filtersPanel}
  {(filteredPaymentsList.length === 0 && !loading) ?
          <div style={{ textAlign: "center", marginTop: "20px", fontSize:"14px" }}>Нет данных
          </div> : <></>}
  <div className="client-items-payments"
  >
    {filteredPaymentsList.map((item) => (
      <ClientItemPayment item={item} key={item.id} />
    ))}
  </div>
  <div
    className="client-item-result"
    style={{
      position: "sticky",
      bottom: 0,
      background: "white",
      padding: "10px 12px",
      borderTop: "1px solid #eee",
      zIndex: 10
    }}
  >
    {(() => {
      const totalIn = filteredPaymentsList.reduce(
        (sum, item) => sum + (item.vid === 1 || item.vid === 2 ? Number(item.syma || 0) : 0),
        0
      );
      const totalOut = filteredPaymentsList.reduce(
        (sum, item) => sum + (item.vid === -1 ? Number(item.syma || 0) : 0),
        0
      );
      const total = totalIn - totalOut;

      return (
        <div className="client-item-line-bold-double">
          <div className="client-item-clip">Итого</div>
          <div
            className="client-item-clip-right"
            style={{ color: total >= 0 ? "green" : "red" }}
          >
            {total.toFixed(2)}
          </div>
        </div>
      );
    })()}
  </div>

</Form>


  ]
  return (
    <>
      {renderedTable}
    </>
  );
};

export default ClientPayments;
